/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface BookingTolerancesFormValidationData
 */
export interface BookingTolerancesFormValidationData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    description?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    relevance?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    brandAndMarket?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    toleranceConfiguration?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    currency?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    toleranceAmountUp?: ValidationMessage;
    /**
     * 
     * @type {ValidationMessage}
     * @memberof BookingTolerancesFormValidationData
     */
    toleranceAmountDown?: ValidationMessage;
}

export function BookingTolerancesFormValidationDataFromJSON(json: any): BookingTolerancesFormValidationData {
    return BookingTolerancesFormValidationDataFromJSONTyped(json, false);
}

export function BookingTolerancesFormValidationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingTolerancesFormValidationData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : ValidationMessageFromJSON(json['description']),
        'relevance': !exists(json, 'relevance') ? undefined : ValidationMessageFromJSON(json['relevance']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : ValidationMessageFromJSON(json['brandAndMarket']),
        'toleranceConfiguration': !exists(json, 'toleranceConfiguration') ? undefined : ValidationMessageFromJSON(json['toleranceConfiguration']),
        'currency': !exists(json, 'currency') ? undefined : ValidationMessageFromJSON(json['currency']),
        'toleranceAmountUp': !exists(json, 'toleranceAmountUp') ? undefined : ValidationMessageFromJSON(json['toleranceAmountUp']),
        'toleranceAmountDown': !exists(json, 'toleranceAmountDown') ? undefined : ValidationMessageFromJSON(json['toleranceAmountDown']),
    };
}

export function BookingTolerancesFormValidationDataToJSON(value?: BookingTolerancesFormValidationData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': ValidationMessageToJSON(value.description),
        'relevance': ValidationMessageToJSON(value.relevance),
        'brandAndMarket': ValidationMessageToJSON(value.brandAndMarket),
        'toleranceConfiguration': ValidationMessageToJSON(value.toleranceConfiguration),
        'currency': ValidationMessageToJSON(value.currency),
        'toleranceAmountUp': ValidationMessageToJSON(value.toleranceAmountUp),
        'toleranceAmountDown': ValidationMessageToJSON(value.toleranceAmountDown),
    };
}


